import React, { useEffect, useState } from "react";
import AddUpdateUI from "./AddUpdateUI";
import { useDispatch } from "react-redux";
import {
  getPerformanceVenues,
  getVenues,
  getInitiatives,
} from "../../../services/CommonServices";

const AddUpdateSchedule = ({ formik, extraProps }) => {
  const dispatch = useDispatch();
  const [schedules, setSchdules] = useState(null);
  const [selectedRelationData, setSelectedRelationData] = useState({
    initiative: {},
    venue: {},
    performanceVenue: {},
  });
  useEffect(() => {
    if (
      extraProps &&
      extraProps?.schedule &&
      extraProps?.schedule?.length > 0
    ) {
      let currentSchedules = {};
      extraProps?.schedule?.forEach((sch) => {
        if (sch.date in currentSchedules) {
          currentSchedules[sch.date].push({
            start_time: sch.start_time,
            end_time: sch.end_time,
          });
        } else {
          currentSchedules[sch.date] = [
            {
              start_time: sch.start_time,
              end_time: sch.end_time,
            },
          ];
        }
      });
      setSchdules(currentSchedules);
    }
    if (extraProps) {
      let tmpRelations = { ...selectedRelationData };
      if (extraProps?.initiative) {
        tmpRelations.initiative = {
          label: extraProps.initiative.title,
          value: extraProps.initiative._id,
        };
      }
      if (extraProps?.venue) {
        tmpRelations.venue = {
          label: extraProps.venue.title,
          value: extraProps.venue._id,
        };
      }
      if (extraProps?.performanceVenue) {
        tmpRelations.performanceVenue = {
          label: `${extraProps.performanceVenue.title} (Capacity: ${extraProps.performanceVenue.capacity || 0})`,
          value: extraProps.performanceVenue._id,
        };
      }
      setSelectedRelationData(tmpRelations);
    }
  }, [extraProps]);
  useEffect(() => {
    dispatch(getInitiatives());
    dispatch(getVenues());
  }, []);
  useEffect(() => {
    if (selectedRelationData.venue.value) {
      dispatch(
        getPerformanceVenues({ venue: selectedRelationData.venue.value })
      );
    }
  }, [selectedRelationData]);

  return (
    <AddUpdateUI
      formik={formik}
      selectedRelationData={selectedRelationData}
      setSelectedRelationData={setSelectedRelationData}
      parentData={extraProps?.parentData}
      schedules={schedules}
    />
  );
};

export default AddUpdateSchedule;
